import request from "_private/utils/request";

/**
 * @description 登录
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchLogin(data) {
    return request({
        url: "/login",
        method: "post",
        data
    });
}

/**
 * @description 登出
 * @author sunxiaodong
 * @export
 * @returns
 */
export function FetchLogout() {
    return request({
        url: "/logout",
        method: "get"
    });
}
